// @ts-check
import { Box, Flex, Text } from '~/design-system';
import { Trans } from '@lingui/macro';

const EMPTY = '(empty)';

/**
 * Renders the select boxes where the header row and data row are selected
 * @param {Object} props
 * @param {[String[]]} props.sampleRows - the array of arrays with the data
 * @param {number} [props.headerRowIndex] - the index of the row with column names, if defined
 * @param {number} [props.dataRowIndex] - the index of the first row of data, if defined
 * @param {function} props.onHeaderRowIndexChange - callback when the header row index is changed
 * @param {function} props.onDataRowIndexChange - callback when the data row index is changed
 * @param {Object} [props.rest]
 */
export default function SelectHeaderAndData({
  sampleRows,
  headerRowIndex,
  dataRowIndex,
  onHeaderRowIndexChange,
  onDataRowIndexChange,
  ...rest
}) {
  return (
    <Flex sx={{ justifyContent: 'center' }} {...rest}>
      <Box sx={{ textAlign: 'center' }}>
        <Text>
          <Trans>Header row</Trans>
        </Text>
        <select
          sx={{ minWidth: '110px', height: 24 }}
          onChange={({ target: { value } }) => {
            const _value = parseInt(value);

            if (dataRowIndex && dataRowIndex <= _value) {
              onDataRowIndexChange(_value + 1);
            }
            if (value === EMPTY) {
              onHeaderRowIndexChange(null);
            } else {
              onHeaderRowIndexChange(_value);
            }
          }}
          defaultValue={headerRowIndex}
          value={headerRowIndex}
        >
          <option value={EMPTY}>Select</option>
          {sampleRows?.map((row, index) => {
            if (index === sampleRows.length - 1) {
              return (
                <option disabled={true} key={index + 1} value={index + 1}>
                  {index + 1}
                </option>
              );
            } else {
              return (
                <option key={index + 1} value={index + 1}>
                  {index + 1}
                </option>
              );
            }
          })}
        </select>
      </Box>
      <Box sx={{ textAlign: 'center', marginLeft: 4 }}>
        <Text>Data starts at</Text>
        <select
          sx={{ minWidth: '110px', height: 24 }}
          onChange={({ target: { value } }) => {
            const _value = parseInt(value);
            if (headerRowIndex && headerRowIndex >= _value) {
              onHeaderRowIndexChange(_value - 1);
            }
            if (value === EMPTY) {
              onDataRowIndexChange(null);
            } else {
              onDataRowIndexChange(parseInt(value));
            }
          }}
          defaultValue={dataRowIndex}
          value={dataRowIndex}
        >
          <option value={EMPTY}>Select</option>
          {sampleRows?.map((row, index) => {
            if (index === 0) {
              return (
                <option disabled={true} key={index + 1} value={index + 1}>
                  {index + 1}
                </option>
              );
            } else {
              return (
                <option key={index + 1} value={index + 1}>
                  {index + 1}
                </option>
              );
            }
          })}
        </select>
      </Box>
    </Flex>
  );
}
